/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Marker_EndInputs */

const vi_tracking_marker_end = /** @type {(inputs: Tracking_Marker_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc`)
};

/**

* @param {Tracking_Marker_EndInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_marker_end = /** @type {((inputs?: Tracking_Marker_EndInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Marker_EndInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_marker_end(inputs)
});